const SnapchatIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M16.4981 12.7185C16.4981 12.7185 16.3483 13.3171 15.561 13.4665C14.8111 13.5786 14.3608 13.6533 14.3608 13.6533L14.1735 14.6627C14.1735 14.6627 13.6108 14.5133 12.9733 14.5133C12.7111 14.5133 12.4106 14.5507 12.1485 14.6254C11.436 14.8121 10.7236 15.5975 9.74897 15.9346C9.52428 16.0093 9.2612 16.0466 8.99906 16.084C8.73692 16.084 8.47385 16.0093 8.24916 15.9346C7.27456 15.5984 6.5621 14.8121 5.84964 14.6254C5.5875 14.5507 5.28698 14.5133 5.02484 14.5133C4.38728 14.5133 3.82462 14.6627 3.82462 14.6627L3.63737 13.6533C3.63737 13.6533 3.2245 13.6159 2.43715 13.4665C1.68724 13.3544 1.5 12.7185 1.5 12.7185C1.5 12.7185 1.68724 12.6812 2.4746 12.4571C3.26195 12.2329 4.31238 11.0358 4.76177 10.3252C5.21208 9.57718 5.0239 9.20271 4.64942 8.94124C4.27493 8.67977 3.07471 8.60507 3.11216 8.0812C3.14961 7.55733 3.78717 7.59469 3.78717 7.59469C4.49963 7.96915 5.02484 7.7441 5.02484 7.7441V5.87366C5.02484 3.66706 6.82518 1.87134 9 1.83398C11.2123 1.87134 12.9752 3.66706 12.9752 5.87366V7.7441C12.9752 7.7441 13.4629 7.96821 14.2128 7.59469C14.2128 7.59469 14.8504 7.55733 14.8878 8.0812C14.9253 8.60507 13.7251 8.64242 13.3506 8.94124C12.9752 9.20271 12.8254 9.61453 13.2382 10.3252C13.6886 11.0731 14.738 12.2329 15.5254 12.4571C16.3128 12.6812 16.5 12.7185 16.5 12.7185H16.4981Z' />
      </svg>
    </span>
  );
};

export default SnapchatIcon;
